<div class="modal right" id="editCustomer" tabindex="-1" role="dialog" aria-labelledby="editCustomerLabel">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" id="print-content">
            <div class="modal-header hide-print">
                <div class="modal-title">
					<h4 id="editCustomerLabel" ng-if="!customer.id">New Customer</h4>
                    <h4 id="editCustomerLabel" ng-if="customer.id">Edit Customer</h4>
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="icon-close-circle"></i>
                </button>
            </div>
            <div class="modal-body order-detail-page">
                <div class="modal-body-container">
					<div class="tab-content">
						<div class="tab-pane active">
							<div class="row">
								<div class="col-md-12" ng-if="customer">
									<form ng-submit="updateCustomer()" class="form-horizontal allcp-form">
										<div class="row">
											<div class="col-md-9">
												<div class="row">
													<div class="col pr-2">
														<div class="form-group floating">
															<input type="text" class="form-control " placeholder="Company Name" ng-model="customer.customer_name" required>
															<label>
																Company Name
															</label>
														</div>
													</div>
													<div class="col pl-2">
														<div class="form-group floating">
															<input type="text" class="form-control " placeholder="Doing Business As (DBA)" ng-model="customer.dba_name">
															<label>
																Doing Business As (DBA)
															</label>
														</div>
													</div>
												</div>
												<div class="form-group floating">
													<input 
														type="text" 
														google-place
														ng-model="customer.address" 
														placeholder="Street Address" 
														ng-change="getAddress(customer.address)" 
														class="form-control"
														autocomplete="off"
														required>
													<label>
														Street Address
													</label>
												</div>
												<div class="form-group floating">
													<input type="text" ng-model="customer.address_two" placeholder="Apartment, Suite, Building (Optional)" class="form-control ">
													<label>
														Apartment, Suite, Building (Optional)
													</label>
												</div>
												<div class="row">
													<div class="col pr-2">
														<div class="form-group floating">
															<input type="text" placeholder="City" ng-model="customer.city" required class="form-control ">
															<label>
																City
															</label>
														</div>
													</div>
													<div class="col pl-2 pr-2">
														<div class="form-group floating">
															<select ng-model="customer.state" class="form-control ">
																<option value="">Select State</option>
																<option value="{{ state.name }}" ng-repeat="state in states track by $index">{{ state.name }}</option>
															</select>
															<label>
																State
															</label>
														</div>
													</div>
													<div class="col pl-2">
														<div class="form-group floating">
															<input type="text" ng-model="customer.zipcode" placeholder="Zipcode" class="form-control ">
															<label>
																Zipcode
															</label>
														</div>
													</div>
												</div>
												<div class="form-group floating">
													<input type="text" placeholder="Authorized Name" class="form-control " ng-model="customer.authorized">
													<label>Authorized Name</label>
												</div>
												<div class="row">
													<div class="col">
														<div class="form-group floating">
															<input type="text" name="store-phone" ui-mask="(999) 999-9999" ui-mask-placeholder=" " ui-mask-placeholder-char=" " placeholder="Phone Number" class="form-control " ng-model="customer.phone_number" required>
															<label>Phone Number</label>
														</div>
													</div>
													<div class="col">
														<div class="form-group floating">
															<input type="text" name="store-phone" ui-mask="(999) 999-9999" ui-mask-placeholder=" " ui-mask-placeholder-char=" " placeholder="Customer Service Phone Number" class="form-control " ng-model="customer.cs_phone_number">
															<label>Customer Service Phone Number</label>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col">
														<div class="form-group floating">
															<input type="text" autocomplete="off" class="form-control " placeholder="Email" ng-model="customer.email" required>
															<label>Email</label>
														</div>
													</div>
													<div class="col">
														<div class="form-group floating">
															<input type="password" autocomplete="off" placeholder="******" class="form-control " ng-model="customer.password">
															<label>Password</label>
														</div>
													</div>
												</div>

												<div class="form-group floating">
													<input type="number" step="any" string-to-number ng-model="customer.online_payment_factor" class="form-control " placeholder="Price Per Order">
													<label>Price Per Order</label>
												</div>

												<div class="form-group floating">
													<input type="number" step="any" string-to-number ng-model="customer.comission_rate" class="form-control" placeholder="Comission Rate">
													<label>Comission Rate</label>
												</div>

												<div class="checkbox-custom mt10">
													<input type="checkbox" ng-model="customer.show_order_on_maps" id="show_order">
													<label for="show_order">Show Orders on Map</label>
												</div>

											</div>
											<div class="col-md-3">
												<div class="fileupload fileupload-new" data-provides="fileupload">
													<div class="fileupload-preview thumbnail">
														<img ng-if="customer.logo" 
															class="img-responsive center" 
															style="height:220px"
															ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ customer.logo }}" />
														<i ng-if="!customer.logo" class="icon-drag-icon"></i>
														<p>Drag logo here</p>
														<div class="line-seperator">
															<div class="line"></div>
															<p>OR</p>
															<div class="line"></div>
														</div>
														<div class="logo_upload" ng-repeat="item in logo.queue" style="width:50%">
															<div class="progress" ng-if="proccessProfile">
																<div 
																	class="progress-bar progress-bar-success progress-bar-striped active" 
																	role="progressbar" 
																	aria-valuenow="60" 
																	aria-valuemin="0" 
																	aria-valuemax="100" 
																	ng-style="{ 'width': item.progress + '%' }"
																	>
																</div>
															</div>
														</div>
														<span class="btn btn-outline btn-file">
															<span class="fileupload-new">Select</span>
															<input type="file" nv-file-select uploader="logo">
														</span>
													</div>
												</div>
											</div>
											<!-- <div class="col-md-12">
												<div id="mapCustomer" style="height:400px; margin-top:30px;"></div>
											</div> -->
										</div>

										<div class="clearfix"></div>

										<div class="form-group floating pln mt-4">
											<div class="col-md-12 pln">
												<button type="submit" class="hod-button blue">
													<span ng-if="!customer.id">CREATE</span>
                    								<span ng-if="customer.id">UPDATE</span>
												</a>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</div>
